<template>
  <div class="collage-photo-item" @mouseenter="showFavorite=true" @mouseleave="showFavorite=false">
    <div class="j-media"
         :class="{'cursor-pointer': !media.is_placeholder}"
         ref="sentinel"
         @click="onClick">
      <ImageMedia :media="media" :is-paid="isPaid"/>
    </div>
    <CartActions :digital-item-id="digitalItemId"
                  :media="media"
                  :gallery="gallery"
                  v-if="isPaid"
                  v-show="!media.is_placeholder"/>

    <transition name="fade" v-if="favoriteEnabled">
      <FavoriteAction :icon-width="22" :media="media" v-show="!media.is_placeholder && (showFavorite || media.favorite)" v-if="!isPaid"/>
    </transition>
  </div>
</template>

<script>
import {observeMedia} from "@/utils/media";
import CartActions from "@/domain/galleries/medias/CartActions.vue";

import ImageMedia from "@/domain/galleries/components/ImageMedia.vue";
import {mediaTypes} from "@/domain/galleries/constants";
import FavoriteAction from "@/domain/galleries/medias/FavoriteAction.vue";

export default {
  name: "Media",
  components: {FavoriteAction, ImageMedia, CartActions},
  emits: ['select', 'firstVisible'],
  data() {
    return {
      loading: false,
      addedToCart: false,
      showFavorite: false
    }
  },
  props: {
    media: {
      type: [Object, Number],
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    gallery: {
      type: Object,
      required: false
    },
    favoriteEnabled: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.observeMedia('.j-media', this.media.id, this.media.media_type === mediaTypes.VIDEO)

    // if this is the first media and it's a placeholder, create an observer to fire media load
    if (this.index === 0 && this.media.is_placeholder) {
      this.createObserver()
    }

  },
  methods: {
    observeMedia,
    onClick() {
      if (this.media.is_placeholder) return
      this.$emit('select', this.index)
    },
    createObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      }
      this.observer = new IntersectionObserver(this.handleIntersect, options)
      this.observer.observe(this.$refs.sentinel)
    },
    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$emit('firstVisible')
          this.observer.unobserve(this.$refs.sentinel)
        }
      })
    }
  }
}
</script>

